import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useClientContext } from "clients";
import { useStateContext } from "state";

const useResendPassword = () => {
  const queryClient = useQueryClient();
  const clients = useClientContext();
  const state = useStateContext();

  return useMutation({
    mutationFn: (email: string) =>
      clients.management.resendTemporaryPassword(email),
    onSuccess: () =>
      queryClient.invalidateQueries(["listUsers", state.tokens?.user_id]),
  });
};

export default useResendPassword;
